$('.js-link').on('click', function() {
  var url = location.href;
  decodeUrl = decodeURIComponent(url);
  decodeUrl = decodeUrl.substring(0, decodeUrl.indexOf("?"))
  location.replace(decodeUrl + '?view=reset');
});

$(function() {
    if ($('.agree-check input').is(':checked')) {
    $('.section-register-btn input').prop('disabled', false);
    } else {
    $('.section-register-btn input').prop('disabled', true);
    }
  $('.agree-check input').on('change', function(){
    if ($(this).is(':checked')) {
    $('.section-register-btn input').prop('disabled', false);
    } else {
    $('.section-register-btn input').prop('disabled', true);
    }
  });
});

$(function(){
    
    var arySpinnerCtrl = [];
    var spin_speed = 20; //変動スピード
    
    //長押し押下時
    $('.btnspinner').on('touchstart mousedown click', function(e){
        console.log('test');
        if(arySpinnerCtrl['interval']) return false;
        var target = $(this).data('target');
        arySpinnerCtrl['target'] = target;
        arySpinnerCtrl['timestamp'] = e.timeStamp;
        arySpinnerCtrl['cal'] = Number($(this).data('cal'));
        //クリックは単一の処理に留める
        if(e.type == 'click'){
            spinnerCal();
            arySpinnerCtrl = [];
            return false;
        }
        //長押し時の処理
        setTimeout(function(){
            //インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
            if(!arySpinnerCtrl['interval'] && arySpinnerCtrl['timestamp'] == e.timeStamp){
                arySpinnerCtrl['interval'] = setInterval(spinnerCal, spin_speed);
            }
        }, 500);
    });
    
    //長押し解除時 画面スクロールも解除に含む
    $(document).on('touchend mouseup scroll', function(e){
        if(arySpinnerCtrl['interval']){
            clearInterval(arySpinnerCtrl['interval']);
            arySpinnerCtrl = [];
        }
    });
    
    //変動計算関数
    function spinnerCal(){
        var target = $(arySpinnerCtrl['target']);
        var num = Number(target.val());
        num = num + arySpinnerCtrl['cal'];
        if(num > Number(target.data('max'))){
            target.val(Number(target.data('max')));
        }else if(Number(target.data('min')) > num){
            target.val(Number(target.data('min')));
        }else{
            target.val(num);
        }
    }

    //セレクトボックス移動
    function select_append(){

      var w = $(window).width();
      var s = 767;

        if (w <= s) {
          $('.section-cart-table tr').each(function(){
          	target = $(this).find('.cart-txt');
            $(this).find('.spinner-area').appendTo(target);
          });
        } else {
          $('.section-cart-table tr').each(function(){
          	target = $(this).find('.cart-quantity');
            $(this).find('.spinner-area').appendTo(target);
          });
        }
    }

    $(window).on('resize', function(){
        select_append();
    });

    $(function(){
        select_append();
    });
});

$(function(){
    if($('.form-main-error').length){
    $('<div class="error-close"></div>').prependTo('.form-main-error ul');
    $('.error-close').on('click', function() {
      $('.form-main-error ul').fadeOut();
    });
    }
});

$(function() {
  const pageTop = $(".back-top");
  bnrScroll(pageTop);
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });
  function bnrScroll(pageTop) {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $("footer").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(pageTop).css({
          position: "absolute",
          top: "-50px",
          bottom: "inherit",
        });
      } else {
        $(pageTop).css({
          position: "fixed",
          bottom: "25px",
          top: "inherit",
        });
      }
    });
  }
});


$(function(){
    var imgHeight = $('.section-detail-img-list').height();
    var txtHeight = $('.section-detail-txt-inner').height();
    if( imgHeight >= txtHeight ){
		 $('.section-detail-txt-inner').addClass('sticky');
    } else {
      	 $('.section-detail-img-list').addClass('sticky');
    }
});

$(function(){
　ityped.init(document.querySelector("#ityped1"), {
    strings: ['OPENING SOON'],
    typeSpeed:  100,             //タイピングのスピード
    backSpeed:  50,              //文字が消えていくときのスピード
    startDelay: 500,             //タイピングが始まるまでの時間
    backDelay:  500,             //タイピングが終わって消え始めるまでの時間
    loop: false,                 //繰り返しの有無（trueかfalseで指定）
    showCursor: true,            //カーソル表示の有無（trueかfalseで指定）
    placeholder: false,          //プレースホルダーでのアニメーション（trueかfalseで指定）
    disableBackTyping: false,    //文字を消していく動作の有無（trueかfalseで指定）
    cursorChar: "|",   
    onFinished: function(){
      $('.ityped-cursor').css('opacity','0');
    },//カーソルとして表示させる文字を" "内に指定
　 })
 
 　ityped.init(document.querySelector("#ityped2"), {
    strings: ['OPENING SOON'],
    typeSpeed:  100,             //タイピングのスピード
    backSpeed:  50,              //文字が消えていくときのスピード
    startDelay: 500,             //タイピングが始まるまでの時間
    backDelay:  500,             //タイピングが終わって消え始めるまでの時間
    loop: false,                 //繰り返しの有無（trueかfalseで指定）
    showCursor: true,            //カーソル表示の有無（trueかfalseで指定）
    placeholder: false,          //プレースホルダーでのアニメーション（trueかfalseで指定）
    disableBackTyping: false,    //文字を消していく動作の有無（trueかfalseで指定）
    cursorChar: "|",             //カーソルとして表示させる文字を" "内に指定
    onFinished: function(){
      $('.ityped-cursor').css('opacity','0');
    },
　 })
});